import React from "react";
import "../../../styles/contactos.css";
import site from "../../../imgs/Icons/site.svg";
import tel from "../../../imgs/Icons/tel.svg";
import fax from "../../../imgs/Icons/fax.svg";
import email from "../../../imgs/Icons/email.svg";
import morada from "../../../imgs/Icons/morada.svg";
import time from "../../../imgs/Icons/time_black.svg";
import { withNamespaces } from "react-i18next";

const ServicosUA = ({ t }) => {

  const formatPhoneValues = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return `+351 ${phoneNumber.slice(0, 3)} 
  ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
  }

  return (
    <>
      <div
        className="accordion accordions_margin"
        id="accordionExample_servicos"
      >
        {/* 1 - SERVIÇOS DE ACAO SOCIAL */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="sAcaoSocial">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cSAcaoSocial"
              aria-expanded="true"
              aria-controls="cSAcaoSocial"
            >
              {t('moduleContactosEstruturas:S2.A.A1.T')}
            </button>
          </h2>
          <div
            id="cSAcaoSocial"
            className="accordion-collapse collapse"
            aria-labelledby="sAcaoSocial"
            data-bs-parent="#accordionExample_servicos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S2.A.A1.P.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S2.A.A1.P.P1'))}
                  </a> {t('moduleContactosEstruturas:S2.A.A1.P.P2')}
                </p>
                <p className="p-bold marginT-p">
                  {t('moduleContactosEstruturas:S2.A.A1.ST1.ST')}
                </p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S2.A.A1.ST1.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S2.A.A1.ST1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S2.A.A1.ST1.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S2.A.A1.ST1.P2'))}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S2.A.A1.ST1.P3')}
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S2.A.A1.ST1.P4')}>
                    {t('moduleContactosEstruturas:S2.A.A1.ST1.P4')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEstruturas:S2.A.A1.ST1.P5')}
                  >
                    {t('moduleContactosEstruturas:S2.A.A1.ST1.P5')}
                  </a>
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEstruturas:S2.A.A1.ST1.P6')}
                </p>
                <p className="p-bold marginT-p">
                  {t('moduleContactosEstruturas:S2.A.A1.ST2.ST')}
                </p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S2.A.A1.ST2.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S2.A.A1.ST2.P1'))}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link text-wrap"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEstruturas:S2.A.A1.ST2.P2')}
                  >
                    {t('moduleContactosEstruturas:S2.A.A1.ST2.P2')}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>{t('moduleContactosEstruturas:S2.A.A1.ST2.P3.P1')}
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S2.A.A1.ST2.P3.P2')}>
                    {t('moduleContactosEstruturas:S2.A.A1.ST2.P3.P2')}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>{t('moduleContactosEstruturas:S2.A.A1.ST2.P4.P1')}
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S2.A.A1.ST2.P4.P2')}>
                    {t('moduleContactosEstruturas:S2.A.A1.ST2.P4.P2')}
                  </a>
                </p>
                <p className="p-bold marginT-p">
                  {t('moduleContactosEstruturas:S2.A.A1.ST3.ST')}
                </p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S2.A.A1.ST3.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S2.A.A1.ST3.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S2.A.A1.ST3.P2')}>
                    {t('moduleContactosEstruturas:S2.A.A1.ST3.P2')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEstruturas:S2.A.A1.ST3.P3.P1')}
                  >
                    {t('moduleContactosEstruturas:S2.A.A1.ST3.P3.P1')}
                  </a>
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEstruturas:S2.A.A1.ST3.P3.P2')}
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S2.A.A1.ST3.P4')}
                </p>
                <p className="p-bold marginT-p">
                  {t('moduleContactosEstruturas:S2.A.A1.ST4.ST')}
                </p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S2.A.A1.ST4.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S2.A.A1.ST4.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S2.A.A1.ST4.P2')}>
                    {t('moduleContactosEstruturas:S2.A.A1.ST4.P2')}
                  </a>
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEstruturas:S2.A.A1.ST4.P3')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 2 - SERVICOS BIBLIOTECA */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="sBiblioteca">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cSBiblioteca"
              aria-expanded="true"
              aria-controls="cSBiblioteca"
            >
              {t('moduleContactosEstruturas:S2.A.A2.T')}
            </button>
          </h2>
          <div
            id="cSBiblioteca"
            className="accordion-collapse collapse"
            aria-labelledby="sBiblioteca"
            data-bs-parent="#accordionExample_servicos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S2.A.A2.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S2.A.A2.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S2.A.A2.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S2.A.A2.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S2.A.A2.P3')}>
                    {t('moduleContactosEstruturas:S2.A.A2.P3')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEstruturas:S2.A.A2.P4')}
                  >
                    {t('moduleContactosEstruturas:S2.A.A2.P4')}
                  </a>
                </p>
                <p className="break_line">
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEstruturas:S2.A.A2.P5.P1')}
                  >
                    {t('moduleContactosEstruturas:S2.A.A2.P5.P1')}
                  </a>{t('moduleContactosEstruturas:S2.A.A2.P5.P2')}
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S2.A.A2.P6')}
                </p>
                <p className="p-bold marginT-p">{t('moduleContactosEstruturas:S2.A.A2.ST1.ST')}</p>
                <p className="break_line">
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEstruturas:S2.A.A2.ST1.P1')}
                  >
                    {t('moduleContactosEstruturas:S2.A.A2.ST1.P1')}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 3 - SERVICOS GESTAO */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="sGestao">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cSGestao"
              aria-expanded="true"
              aria-controls="cSGestao"
            >
              {t('moduleContactosEstruturas:S2.A.A3.T')}
            </button>
          </h2>
          <div
            id="cSGestao"
            className="accordion-collapse collapse"
            aria-labelledby="sGestao"
            data-bs-parent="#accordionExample_servicos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p className="p-bold">{t('moduleContactosEstruturas:S2.A.A3.ST1.ST')}</p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" href={"tel:+351" +
                    t('moduleContactosEstruturas:S2.A.A3.ST1.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S2.A.A3.ST1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S2.A.A3.ST1.P2')}>
                    {t('moduleContactosEstruturas:S2.A.A3.ST1.P2')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEstruturas:S2.A.A3.ST1.P3')}
                  >
                    {t('moduleContactosEstruturas:S2.A.A3.ST1.P3')}
                  </a>
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEstruturas:S2.A.A3.ST1.P4')}
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S2.A.A3.ST1.P5')}
                </p>
                <p className="p-bold marginT-p">
                {t('moduleContactosEstruturas:S2.A.A3.ST2.ST')}
                </p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" href={"tel:+351" +
                    t('moduleContactosEstruturas:S2.A.A3.ST2.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S2.A.A3.ST2.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S2.A.A3.ST2.P2')}>
                    {t('moduleContactosEstruturas:S2.A.A3.ST2.P2')}
                  </a>
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEstruturas:S2.A.A3.ST2.P3')}
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S2.A.A3.ST2.P4')}
                </p>
                <p className="p-bold marginT-p">
                {t('moduleContactosEstruturas:S2.A.A3.ST3.ST')}
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S2.A.A3.ST3.P1')}>
                    {t('moduleContactosEstruturas:S2.A.A3.ST3.P1')}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 4 - SERVICOS TECNOLOGIAS */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="sTecnologias">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cSTecnologias"
              aria-expanded="true"
              aria-controls="cSTecnologias"
            >
              {t('moduleContactosEstruturas:S2.A.A4.T')}
            </button>
          </h2>
          <div
            id="cSTecnologias"
            className="accordion-collapse collapse"
            aria-labelledby="sTecnologias"
            data-bs-parent="#accordionExample_servicos"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" href={"tel:+351" +
                    t('moduleContactosEstruturas:S2.A.A4.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S2.A.A4.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" href={"fax:+351" +
                    t('moduleContactosEstruturas:S2.A.A4.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S2.A.A4.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S2.A.A4.P3')}>
                    {t('moduleContactosEstruturas:S2.A.A4.P3')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    target="_blank"
                    rel="noreferrer"
                    href={t('moduleContactosEstruturas:S2.A.A4.P4')}
                  >
                    {t('moduleContactosEstruturas:S2.A.A4.P4')}
                  </a>
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEstruturas:S2.A.A4.P5')}
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S2.A.A4.P6')}
                </p>
                <p>
                  <img src={time} alt={t('moduleContactosEstruturas:Alt.Alt6')}></img>{t('moduleContactosEstruturas:S2.A.A4.P7')}
                </p>
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" href={"tel:+351" +
                    t('moduleContactosEstruturas:S2.A.A4.P8')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S2.A.A4.P8'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S2.A.A4.P9')}>
                    {t('moduleContactosEstruturas:S2.A.A4.P9')}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces()(ServicosUA);
